import { FC, useEffect, useRef } from 'react';
import { useAppSelector } from '../../store';
import { NavigationItem } from '../navigation-item';
import styles from './index.module.css';

export const Pages: FC = () => {
    const { pages, activeTab } = useAppSelector((state) => state.app);
    const actualPages = pages?.get(activeTab!);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const actualPagesList = pages!.get(activeTab!) || [];
        if (!actualPagesList.length || !containerRef.current) return;

        const element = containerRef.current;
        element.scrollTo({
            left: element.clientWidth * actualPagesList.length,
            behavior: 'smooth',
        });
    }, [pages, activeTab]);

    return (
        <div id={styles.background} ref={containerRef}>
            {actualPages?.map((page, index) => (
                <div key={index} className={styles.pageWrapper}>
                    <NavigationItem index={index}>{page}</NavigationItem>
                </div>
            ))}
        </div>
    );
};
